import { Component, Input, OnInit } from '@angular/core';

import { IColunaData } from '../../interface/icm-data-generico';

@Component({
    selector: 'icm-coluna-data',
    templateUrl: './view/icm-coluna-data.component.html',
    styleUrls: ['./view/icm-coluna-data.component.scss'],
})
export class IcmColunaDataComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaData;
    @Input() carregando: boolean;

    data: Date;
    corTexto: string = '#000000de';
    corDesabilitado: string = '#00000042';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.data = this.coluna.valor(this.linha);
        if (this.coluna?.cor) this.corTexto = this.coluna.cor(this.linha);
    }
}
